import { render, staticRenderFns } from "./RequestMessengerIndex.vue?vue&type=template&id=39ec9d92"
import script from "./RequestMessengerIndex.vue?vue&type=script&lang=js"
export * from "./RequestMessengerIndex.vue?vue&type=script&lang=js"
import style0 from "./RequestMessengerIndex.vue?vue&type=style&index=0&id=39ec9d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports